import { OfferLiteResponse, OrganisationLiteResponse } from '@/api/generated'
import { PortfolioModel } from '@/shared/models/portfolio-model'

export function toPortfolioItem(
  type: string,
  route: string
): (_: OrganisationLiteResponse) => PortfolioModel {
  return (item: OrganisationLiteResponse | OfferLiteResponse): PortfolioModel => ({
    category: item.categories,
    description: item.description || '',
    href: `/${type}/${item.id}`,
    id: item.id,
    image: item.image,
    title: item.name,
    to: {
      name: route,
      params: {
        id: item.id.toString(),
      },
    },
  })
}
